export default __webpack_public_path__ + "static/media/contact@2x.9e7c8783.webp";